export const SKILLS = {
  TITLE:
    'Which skills are you most confident and comfortable reviewing code for?',
  MAXIMUM_TEXT: "Let's start with these for now. You can add more later.",
  ERROR: 'You must select at least one skill.',
};
